import { langId } from "@escapio/shared/l10n/lang-id";
import { watch as watchInteraction } from "@escapio/shared/event/interaction-observer";

// Make sure event listener ist set, before loading snippet.
import "@escapio/shared/tracker/ConsentObserver";

if (langId === "de") {
	watchInteraction().then(() => {
		const snippet = document.createElement("script");
		snippet.src =
			"https://cdn.stroeerdigitalgroup.de/metatag/live/mdnx_escapio/metaTag.min.js";
		snippet.setAttribute("defer", "");
		snippet.crossOrigin = "anonymous";

		document.head.appendChild(snippet);
	});
}
